module.exports = __webpack_public_path__ + "img/org-review-avg.3ebd6856.svg";